const messages = {
  es: {
    translations: {
      signup: {
        title: "Registro",
        toasts: {
          success:
            "¡El usuario ha sido creado satisfactoriamente! ¡Ahora inicia sesión!",
          fail: "Error creando el usuario. Verifica la data reportada.",
        },
        form: {
          name: "Nombre",
          email: "Correo Electrónico",
          password: "Contraseña",
        },
        buttons: {
          submit: "Regístrate",
          login: "¿Ya tienes una cuenta? ¡Inicia sesión!",
        },
      },
      login: {
        title: "Inicio de Sesión",
        form: {
          email: "Correo Electrónico",
          password: "Contraseña",
        },
        buttons: {
          submit: "Ingresa",
          register: "¿No tienes cuenta? ¡Regístrate!",
        },
      },
      auth: {
        toasts: {
          success: "¡Inicio de sesión exitoso!",
        },
      },
      dashboard: {
        charts: {
          perDay: {
            title: "Tickets hoy: ",
          },
        },
        messages: {
          inAttendance: {
            title: "En servicio"
          },
          waiting: {
            title: "Esperando"
          },
          closed: {
            title: "Finalizado"
          }
        }
      },
      connections: {
        title: "Conexiones",
        toasts: {
          deleted:
            "¡La conexión de WhatsApp ha sido borrada satisfactoriamente!",
        },
        confirmationModal: {
          deleteTitle: "Borrar",
          deleteMessage: "¿Estás seguro? Este proceso no puede ser revertido.",
          disconnectTitle: "Desconectar",
          disconnectMessage: "Estás seguro? Deberá volver a leer el código QR",
        },
        buttons: {
          add: "Agrega WhatsApp",
          disconnect: "Desconectar",
          tryAgain: "Inténtalo de nuevo",
          qrcode: "QR CODE",
          newQr: "Nuevo QR CODE",
          connecting: "Conectando",
        },
        toolTips: {
          disconnected: {
            title: "No se pudo iniciar la sesión de WhatsApp",
            content:
              "Asegúrese de que su teléfono celular esté conectado a Internet y vuelva a intentarlo o solicite un nuevo código QR",
          },
          qrcode: {
            title: "Esperando la lectura del código QR",
            content:
              "Haga clic en el botón 'CÓDIGO QR' y lea el Código QR con su teléfono celular para iniciar la sesión",
          },
          connected: {
            title: "Conexión establecida",
          },
          timeout: {
            title: "Se perdió la conexión con el teléfono celular",
            content:
              "Asegúrese de que su teléfono celular esté conectado a Internet y que WhatsApp esté abierto, o haga clic en el botón 'Desconectar' para obtener un nuevo código QR",
          },
        },
        table: {
          name: "Nombre",
          status: "Estado",
          lastUpdate: "Última Actualización",
          default: "Por Defecto",
          actions: "Acciones",
          session: "Sesión",
        },
      },
      whatsappModal: {
        title: {
          add: "Agrega WhatsApp",
          edit: "Edita WhatsApp",
        },
        form: {
          name: "Nombre",
          default: "Por Defecto",
          greetingMessage: "Mensaje de Bienvenida",
          farewellMessage: "Mensaje de Despedida",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        success: "WhatsApp guardado satisfactoriamente.",
      },
      qrCode: {
        title: "Vincular WhatsApp",
        message: "Escanea el código QR desde tu teléfono para iniciar sesión.",
        tabQr: "Código QR",
        tabPairingCode: "Vincular con Número",
        phoneLabel: "Número de Teléfono (con código de país)",
        phonePlaceholder: "Ej: 573001234567",
        phoneHelperText: "Ingresa el número con el código de país sin el símbolo + ni espacios.",
        requestCode: "Solicitar Código",
        requestingCode: "Generando código...",
        pairingCodeTitle: "Tu código de vinculación es:",
        copyCode: "Copiar Código",
        codeCopied: "¡Código copiado al portapapeles!",
        instructionsTitle: "Pasos para vincular:",
        step1: "Abre WhatsApp en tu teléfono celular.",
        step2: "Toca Menú (tres puntos) o Ajustes > Dispositivos vinculados.",
        step3: "Toca en 'Vincular un dispositivo'.",
        step4: "Selecciona 'Vincular con el número de teléfono' en la parte inferior.",
        step5: "Ingresa el código de 8 dígitos que aparece arriba.",
        qrWaiting: "Generando código QR...",
        qrInstructions: "Abre WhatsApp en tu teléfono, toca Menú o Configuración y selecciona Dispositivos vinculados.",
      },
      contacts: {
        title: "Contactos",
        toasts: {
          deleted: "¡Contacto borrado satisfactoriamente!",
        },
        searchPlaceholder: "Buscar...",
        confirmationModal: {
          deleteTitle: "Borrar",
          importTitlte: "Importar contactos",
          deleteMessage:
            "¿Estás seguro que deseas borrar este contacto? Todos los tickets relacionados se perderán.",
          importMessage:
            "¿Quieres importar todos los contactos desde tu teléfono?",
        },
        buttons: {
          import: "Importar Contactos",
          add: "Agregar Contacto",
        },
        table: {
          name: "Nombre",
          whatsapp: "WhatsApp",
          email: "Correo Electrónico",
          actions: "Acciones",
        },
      },
      contactModal: {
        title: {
          add: "Agregar contacto",
          edit: "Editar contacto",
        },
        form: {
          mainInfo: "Detalles del contacto",
          extraInfo: "Información adicional",
          name: "Nombre",
          number: "Número de Whatsapp",
          email: "Correo Electrónico",
          extraName: "Nombre del Campo",
          extraValue: "Valor",
        },
        buttons: {
          addExtraInfo: "Agregar información",
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        success: "Contacto guardado satisfactoriamente.",
      },
      quickAnswersModal: {
        title: {
          add: "Agregar respuesta rápida",
          edit: "Editar respuesta rápida",
        },
        form: {
          shortcut: "Atajo",
          message: "Respuesta rápida",
          isGroup: "Respuesta Grupal (compartida con todos)",
          group: "Grupal (todos pueden usar)",
          personal: "Personal (solo tú puedes usar)",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        success: "Respuesta rápida guardada correctamente.",
      },
      queueModal: {
        title: {
          add: "Agregar cola",
          edit: "Editar cola",
        },
        form: {
          name: "Nombre",
          color: "Color",
          greetingMessage: "Mensaje de saludo",
        },
        buttons: {
          okAdd: "Añadir",
          okEdit: "Ahorrar",
          cancel: "Cancelar",
        },
      },
      userModal: {
        title: {
          add: "Agregar usuario",
          edit: "Editar usuario",
        },
        form: {
          name: "Nombre",
          email: "Correo Electrónico",
          password: "Contraseña",
          profile: "Perfil",
          whatsapp: "Conexión estándar",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        success: "Usuario guardado satisfactoriamente.",
      },
      chat: {
        noTicketMessage: "Selecciona un ticket para empezar a chatear.",
      },
      ticketsManager: {
        buttons: {
          newTicket: "Nuevo",
        },
        tags: {
          placeholder: "Filtrar por etiqueta",
        },
      },
      ticketsQueueSelect: {
        placeholder: "Departamentos",
      },
      tickets: {
        toasts: {
          deleted: "El ticket en el que estabas ha sido borrado.",
        },
        notification: {
          message: "Mensaje de",
        },
        tabs: {
          open: { title: "Chats" },
          closed: { title: "Resueltos" },
          search: { title: "Buscar" },
          unanswered: { title: "" },
        },
        search: {
          placeholder: "Buscar tickets y mensajes.",
        },
        buttons: {
          showAll: "Todos",
        },
      },
      transferTicketModal: {
        title: "Transferir Ticket",
        fieldLabel: "Escriba para buscar usuarios",
        fieldQueueLabel: "Transferir al departamento",
        fieldConnectionLabel: "Transferir to conexión",
        fieldQueuePlaceholder: "Seleccione un departamento",
        fieldConnectionPlaceholder: "Seleccione una conexión",
        noOptions: "No se encontraron usuarios con ese nombre",
        buttons: {
          ok: "Transferir",
          cancel: "Cancelar",
        },
      },
      ticketsList: {
        pendingHeader: "Leads",
        assignedHeader: "Chats",
        noTicketsTitle: "¡Nada acá!",
        connectionTitle: "Conexión que se está utilizando actualmente.",
        noTicketsMessage:
          "No se encontraron tickets con este estado o término de búsqueda",
        buttons: {
          accept: "Acceptar",
        },
      },
      newTicketModal: {
        title: "Crear Ticket",
        fieldLabel: "Escribe para buscar un contacto",
        add: "Añadir",
        buttons: {
          ok: "Guardar",
          cancel: "Cancelar",
        },
      },
      mainDrawer: {
        listItems: {
          dashboard: "Dashboard",
          connections: "Conexiones",
          tickets: "Tickets",
          contacts: "Contactos",
          quickAnswers: "Respuestas rápidas",
          queues: "Departamentos",
          schedules: "Programación",
          administration: "Administración",
          users: "Usuarios",
          settings: "Configuración",
        },
        appBar: {
          user: {
            profile: "Perfil",
            logout: "Cerrar Sesión",
          },
        },
      },
      notifications: {
        noTickets: "Sin notificaciones.",
      },
      queues: {
        title: "Departamentos",
        table: {
          name: "Nombre",
          color: "Color",
          greeting: "Mensaje de saludo",
          actions: "Comportamiento",
        },
        buttons: {
          add: "Agregar departamento",
        },
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteMessage:
            "¿Estás seguro? ¡Esta acción no se puede revertir! Los tickets en ese departamento seguirán existiendo, pero ya no tendrán ningún departamento asignado.",
        },
      },
      queueSelect: {
        inputLabel: "Departamentos",
      },
      quickAnswers: {
        title: "Respuestas rápidas",
        table: {
          shortcut: "Atajo",
          message: "Respuesta rápida",
          type: "Tipo",
          group: "Grupal",
          personal: "Personal",
          actions: "Acciones",
        },
        buttons: {
          add: "Agregar respuesta rápida",
        },
        toasts: {
          deleted: "Respuesta rápida eliminada correctamente",
        },
        searchPlaceholder: "Buscar ...",
        confirmationModal: {
          deleteTitle:
            "¿Está seguro de que desea eliminar esta respuesta rápida?",
          deleteMessage: "Esta acción no se puede deshacer.",
        },
      },
      users: {
        title: "Usuarios",
        table: {
          name: "Nombre",
          email: "Correo Electrónico",
          profile: "Perfil",
          whatsapp: "Conexión estándar",
          actions: "Acciones",
        },
        buttons: {
          add: "Agregar usuario",
        },
        toasts: {
          deleted: "Usuario borrado satisfactoriamente.",
        },
        confirmationModal: {
          deleteTitle: "Borrar",
          deleteMessage:
            "Toda la información del usuario se perderá. Los tickets abiertos de los usuarios se moverán al departamento.",
        },
      },
      settings: {
        success: "Configuración guardada satisfactoriamente.",
        title: "Configuración",
        settings: {
          userCreation: {
            name: "Creación de usuarios",
            options: {
              enabled: "Habilitado",
              disabled: "Deshabilitado",
            },
          },
          botEnabled: {
            name: "Bot / Flujos Automáticos en general",
            note: "Si se desactiva, el bot se pausará globalmente y no responderá automáticamente a ningún chat.",
            options: {
              enabled: "Habilitado (Bot activo)",
              disabled: "Deshabilitado (Bot pausado)",
            },
          },
          botAutoStopOnReply: {
            name: "Detener bot cuando un asesor responda",
            note: "Si se activa, el bot se quita automáticamente de la conversación en cuanto un miembro del equipo responde desde la plataforma o celular.",
            options: {
              enabled: "Habilitado (Quitar bot al responder)",
              disabled: "Deshabilitado (Mantener bot manual)",
            },
          },
        },
      },
      messagesList: {
        header: {
          assignedTo: "Asignado a:",
          buttons: {
            return: "Devolver a Cola",
            resolve: "Resolver",
            reopen: "Reabrir",
            accept: "Aceptar",
            resetFlow: "Reiniciar Flujo",
            exitFlow: "Sacar del Flujo",
            resetFlowSuccess: "Flujo del bot reiniciado correctamente",
            exitFlowSuccess: "Chat retirado del flujo del bot",
            flowStopped: "Bot Detenido",
          },
        },
      },
      messagesInput: {
        placeholderOpen: "Escriba un mensaje o presione '' / '' para usar las respuestas rápidas registradas",
        placeholderClosed:
          "Vuelva a abrir o acepte este ticket para enviar un mensaje.",
        signMessage: "Firmar",
      },
      contactDrawer: {
        header: "Detalles del contacto",
        buttons: {
          edit: "Editar contacto",
        },
        extraInfo: "Otra información",
      },
      ticketOptionsMenu: {
        delete: "Borrar",
        transfer: "Transferir",
        clean: "Depurar chat",
        confirmationModal: {
          title: "¿Borrar ticket #",
          titleFrom: "del contacto ",
          message:
            "¡Atención! Todos los mensajes relacionados con el ticket se perderán.",
        },
        cleanConfirmationModal: {
          title: "¿Depurar chat #",
          titleFrom: "del contacto ",
          message: "¡Atención! Todos los mensajes de este grupo serán eliminados de la base de datos de manera permanente. Esta acción no se puede deshacer.",
        },
        buttons: {
          delete: "Borrar",
          cancel: "Cancelar",
        },
      },
      confirmationModal: {
        buttons: {
          confirm: "Ok",
          cancel: "Cancelar",
        },
      },
      messageOptionsMenu: {
        delete: "Borrar",
        reply: "Responder",
        forward: "Reenviar",
        confirmationModal: {
          title: "¿Borrar mensaje?",
          message: "Esta acción no puede ser revertida.",
        },
      },
      forwardModal: {
        title: "Reenviar mensaje",
        subtitle: "Selecciona el contacto o ticket al que deseas reenviar el mensaje:",
        searchPlaceholder: "Buscar contacto o ticket...",
        sendButton: "Reenviar",
        sending: "Reenviando...",
        success: "¡Mensaje reenviado exitosamente!",
        error: "Error al reenviar el mensaje.",
        noRecipients: "Por favor selecciona al menos un destinatario.",
        forwardedTag: "Reenviado",
        forwardedManyTag: "Reenviado muchas veces",
      },
      mediaGallery: {
        title: "Galería Multimedia",
        subTitle: "Banco de archivos multimedia exclusivo de la empresa",
        searchPlaceholder: "Buscar fotos, videos o archivos...",
        uploadBtn: "Subir a Galería",
        empty: "No hay archivos en la galería. Haz clic en 'Subir a Galería' para agregar imágenes o videos.",
        uploadModal: {
          title: "Subir Archivo a la Galería",
          fileLabel: "Seleccionar archivo (Foto, Video, Audio o Documento)",
          titleField: "Título o Nombre del Archivo",
          captionField: "Pie de mensaje / Descripción predeterminada (opcional)",
          saveBtn: "Guardar en Galería",
          uploading: "Subiendo...",
          success: "¡Archivo guardado en la galería!",
        },
        pickerModal: {
          title: "Galería de la Empresa",
          searchPlaceholder: "Buscar fotos o videos...",
          captionLabel: "Pie de foto / Mensaje para el cliente (opcional):",
          sendBtn: "Enviar al Cliente",
          sending: "Enviando...",
          noSelection: "Selecciona al menos un archivo de la galería.",
          success: "¡Archivo enviado al cliente exitosamente!",
        },
        tabs: {
          all: "Todos",
          images: "Imágenes",
          videos: "Videos",
          audios: "Audios",
          documents: "Documentos",
        },
        deleteTitle: "¿Eliminar archivo?",
        deleteMessage: "¿Estás seguro de que deseas eliminar este archivo de la galería? Esta acción no se puede deshacer.",
        toasts: {
          deleted: "Archivo eliminado de la galería.",
          updated: "Información actualizada correctamente.",
        },
      },
      backendErrors: {
        ERR_NO_OTHER_WHATSAPP:
          "Debe haber al menos una conexión de WhatsApp predeterminada.",
        ERR_NO_DEF_WAPP_FOUND:
          "No se encontró WhatsApp predeterminado. Verifique la página de conexiones.",
        ERR_WAPP_NOT_INITIALIZED:
          "Esta sesión de WhatsApp no ​​está inicializada. Verifique la página de conexiones.",
        ERR_WAPP_CHECK_CONTACT:
          "No se pudo verificar el contacto de WhatsApp. Verifique la página de conexiones.",
        ERR_WAPP_INVALID_CONTACT: "Este no es un número de whatsapp válido.",
        ERR_WAPP_DOWNLOAD_MEDIA:
          "No se pudieron descargar los medios de WhatsApp. Verifique la página de conexiones.",
        ERR_INVALID_CREDENTIALS: "Error de autenticación. Vuelva a intentarlo.",
        ERR_SENDING_WAPP_MSG:
          "Error al enviar el mensaje de WhatsApp. Verifique la página de conexiones.",
        ERR_DELETE_WAPP_MSG: "No se pudo borrar el mensaje de WhatsApp.",
        ERR_OTHER_OPEN_TICKET: "Ya hay un ticket abierto para este contacto.",
        ERR_SESSION_EXPIRED: "Sesión caducada. Inicie sesión.",
        ERR_USER_CREATION_DISABLED:
          "La creación de usuarios fue deshabilitada por el administrador.",
        ERR_NO_PERMISSION: "No tienes permiso para acceder a este recurso.",
        ERR_DUPLICATED_CONTACT: "Ya existe un contacto con este número.",
        ERR_NO_SETTING_FOUND:
          "No se encontró ninguna configuración con este ID.",
        ERR_NO_CONTACT_FOUND: "No se encontró ningún contacto con este ID.",
        ERR_NO_TICKET_FOUND: "No se encontró ningún ticket con este ID.",
        ERR_NO_USER_FOUND: "No se encontró ningún usuario con este ID.",
        ERR_NO_WAPP_FOUND: "No se encontró WhatsApp con este ID.",
        ERR_CREATING_MESSAGE: "Error al crear el mensaje en la base de datos.",
        ERR_CREATING_TICKET: "Error al crear el ticket en la base de datos.",
        ERR_FETCH_WAPP_MSG:
          "Error al obtener el mensaje en WhtasApp, tal vez sea demasiado antiguo.",
        ERR_QUEUE_COLOR_ALREADY_EXISTS:
          "Este color ya está en uso por otro departamento, elija otro.",
        ERR_WAPP_GREETING_REQUIRED:
          "El mensaje de saludo es obligatorio cuando hay más de un departamento.",
      },
      schedules: {
        title: "Programación",
        table: {
          contact: "Contacto",
          body: "Mensaje",
          sendAt: "Fecha Programada",
          sentAt: "Fecha de Envío",
          status: "Estado",
          actions: "Acciones"
        },
        buttons: {
          add: "Agregar Programación"
        },
        toasts: {
          deleted: "Programación eliminada correctamente"
        },
        searchPlaceholder: "Buscar...",
        confirmationModal: {
          deleteTitle: "¿Desea eliminar este mensaje programado?",
          deleteMessage: "Esta acción no se puede deshacer."
        }
      },
      schedulesModal: {
        title: {
          add: "Programar Mensaje",
          edit: "Editar Mensaje Programado"
        },
        form: {
          contact: "Contacto",
          body: "Mensaje",
          sendAt: "Fecha y Hora"
        },
        buttons: {
          okAdd: "Programar",
          okEdit: "Guardar",
          cancel: "Cancelar"
        },
        success: "Mensaje programado con éxito."
      },
    },
  },
};

export { messages };
